/**
 * Off-site destinations the SPA links to.
 *
 * Here rather than inline in each component because an invite code is exactly
 * the kind of string that gets copied to a second place and then only updated
 * in the first. The support server was already written out in the footer; the
 * billing section needs the same link, and a second literal would eventually
 * point somewhere that no longer exists.
 *
 * Not read from `BASE_URL` or the server's `config/options.js`: those are
 * bot/server-side, and vue-cli only inlines `VUE_APP_*` into the bundle. The
 * bot's own `options.serverInvite` is a `/discord` redirect on our origin,
 * which is the right thing for a Discord embed (short, and re-pointable
 * without a deploy) but pointless here, where we would only be redirecting
 * our own visitors through our own server to reach Discord.
 */

/** The Gamebot support server. */
export const SUPPORT_SERVER_URL = 'https://discord.gg/g3qU24mfbK'

/**
 * Discord's own instructions for managing a Premium App subscription.
 *
 * Deliberately a support article rather than a deep link. A subscription
 * bought through Discord is managed in User Settings → Subscriptions →
 * Premium App Subscriptions, which is a client-side surface with no
 * documented external URL that opens it — and inventing one that half-works
 * is worse than telling someone where to look, because a dead link reads as
 * "this is broken" rather than "click three times".
 */
export const DISCORD_SUBSCRIPTION_HELP_URL =
    'https://support.discord.com/hc/en-us/articles/26729692307351-How-to-Cancel-your-Premium-App-Subscription'
